import { useCallback, useState } from "react"

import { ExecutionRun } from "@vertesia/common"

import { useCompositeState } from "@hooks/use-composite-state"
import { useEventSource } from "@hooks/use-event-source"

import FormState, { FormExecutionStatus } from "@plugins/form/FormState"

import { useUserSession } from "@session/UserSession"

interface StreamingPanelProps {
    run: ExecutionRun
}
export function StreamingPanel({ run }: Readonly<StreamingPanelProps>) {
    const formState = useCompositeState(FormState)

    const [text, setText] = useState("")
    const session = useUserSession()

    const onMessage = (text: string) => {
        formState.streamingText.value = text
        setText(text)
    }

    const onCompletion = (run: ExecutionRun) => {
        formState.executionRun = run
        formState.executionStatus.value = FormExecutionStatus.done
    }

    const urlFn = useCallback(async () => {
        const url = new URL(session.client.runs.getUrl(`/${run.id}/stream`))
        const token = await session.rawAuthToken
        if (!token) {
            throw new Error("No auth token available")
        }

        url.searchParams.set("access_token", token)
        return url.toString()
    }, [run, session.client.runs, session.rawAuthToken])

    useEventSource(urlFn, onMessage, onCompletion)

    let content
    if (text) {
        const lines = text.split("\n")
        content = lines.map((line) => {
            return <div key={crypto.randomUUID()}>{line}</div>
        })
    }

    return <pre className="h-full text-left overflow-auto whitespace-pre-wrap break-all">{content}</pre>
}
